import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditResource = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Resource'
      fields={fields}
      apiPath={`admin/resources/${props.params.resourceId}`}
      successRedirectPath='/write-now/resources'
      buildMenuItems={menuItems}
    />
  )
}

export default EditResource
